var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { RequestClient } from "../basics/request-client.service";
import { WorkflowAssignmentsUrls } from '../../constants/workflow/workflow-assignments.constants';
import { toNative } from '../../utilities/promise-utils';
var WorkflowAssignmentsService = /** @class */ (function () {
    function WorkflowAssignmentsService(requestClient) {
        this.requestClient = requestClient;
    }
    WorkflowAssignmentsService.prototype.getWorkflowAssignments = function (entityId, entityTypeId) {
        return toNative(this.requestClient.post(WorkflowAssignmentsUrls.GetWorkflowAssignments, {}, { entityId: entityId, entityTypeId: entityTypeId }));
    };
    WorkflowAssignmentsService.prototype.getWorkflowState = function (entityId, entityTypeId) {
        return toNative(this.requestClient.post(WorkflowAssignmentsUrls.GetWorkflowState, {}, { entityId: entityId, entityTypeId: entityTypeId }));
    };
    WorkflowAssignmentsService.prototype.reassign = function (assignmentId, userId) {
        return toNative(this.requestClient.post(WorkflowAssignmentsUrls.Reassign, {}, { assignmentId: assignmentId, userId: userId }));
    };
    WorkflowAssignmentsService.prototype.takeOwnership = function (assignmentId) {
        return toNative(this.requestClient.post(WorkflowAssignmentsUrls.TakeOwnership, {}, { assignmentId: assignmentId }));
    };
    WorkflowAssignmentsService.prototype.executeAction = function (workflowStateId, activityName, action, assignmentId, reasonId, remarks, meta) {
        return toNative(this.requestClient.post(WorkflowAssignmentsUrls.ExecuteAction, {}, { workflowStateId: workflowStateId, activityName: activityName, action: action, assignmentId: assignmentId, reasonId: reasonId, remarks: remarks, meta: meta }));
    };
    WorkflowAssignmentsService.prototype.cancelWorkflow = function (workflowStateId, cancellationReasonId, cancellationNotes) {
        return toNative(this.requestClient.post(WorkflowAssignmentsUrls.CancelWorkflow, {}, { workflowStateId: workflowStateId, cancellationReasonId: cancellationReasonId, cancellationNotes: cancellationNotes }));
    };
    WorkflowAssignmentsService = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [RequestClient])
    ], WorkflowAssignmentsService);
    return WorkflowAssignmentsService;
}());
export { WorkflowAssignmentsService };
